// Mobile-only "back to list" bar for master-detail screens.
// Rendered above a detail panel on phones to return to the list view.
// Owns its styles so any screen (jobStyles-based or not) can reuse it.
import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { ArrowLeft } from 'lucide-react';
import { webColors } from '../../constants/webStyles';

export default function MobileDetailBackBar({ label = 'Back', onPress }) {
  return (
    <TouchableOpacity
      style={styles.bar}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={label}
    >
      <ArrowLeft size={18} color={webColors.primary} />
      <Text style={styles.text}>{label}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: webColors.borderLight,
    cursor: 'pointer',
  },
  text: {
    fontSize: 14,
    fontWeight: '600',
    color: webColors.primary,
  },
});
